import { Component } from '@angular/core';

@Component({
	selector: 'app-user-exists-snackbar',
	imports: [],
	templateUrl: './user-exists-snackbar.component.html',
	styleUrls: ['./user-exists-snackbar.component.scss'],
})
export class UserExistsSnackbarComponent {}
